import { reactive } from 'vue'
import { createInjectionState } from '@vueuse/shared'

const [useProvideSectionRefs, useSectionRefs] = createInjectionState(() => {
  const sectionsRefs = reactive({})

  return {
    sectionsRefs
  }
})

export { useProvideSectionRefs, useSectionRefs }
